export default __webpack_public_path__ + "locales/de/Errors.json?hash=18d105d65733c1a44099c9c8bb5e226f";